export default function marquee({ logos }) {
    return {
        logos,
        startMarquee() {
            if (logos.length > 5) {
                const marquee = this.$refs.marquee;

                const calculateSpeed = () => {
                    const windowWidth = window.innerWidth;

                    const baseSpeed = 100;
                    const speed = windowWidth < 768 ? baseSpeed * 5.8 : baseSpeed;
                    const duration = marquee.scrollWidth / speed;

                    marquee.style.animation = `marquee ${duration}s linear infinite`;

                    marquee.addEventListener('animationiteration', () => {
                        marquee.style.animation = 'none';
                        marquee.offsetHeight;
                        marquee.style.animation = `marquee ${duration}s linear infinite`;
                    });
                };

                window.onload = () => {
                    setTimeout(calculateSpeed, 500);
                };

                window.addEventListener('resize', calculateSpeed);
            }
        }
    };
}
